/**
 * @flow
 * @relayHash d24a2c178eaa3a1c9fbefe88ddbd513a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {|
  action: PortfolioItemsAction,
  endPortfolioItemId?: ?string,
  itemsIds?: ?$ReadOnlyArray<?string>,
  note?: ?string,
  portfolioItemsIds?: ?$ReadOnlyArray<?string>,
  portfolioId?: ?string,
  portfolioType?: ?PortfolioType,
  startPortfolioItemId?: ?string,
  targetPortfolioItemId?: ?string,
  userId: string,
  clientMutationId?: ?string,
|};
export type addCartItemMutationVariables = {|
  input: ModifyPortfolioItemsInput
|};
export type addCartItemMutationResponse = {|
  +modifyPortfolioItems: ?{|
    +portfolio: ?{|
      +items: ?{|
        +totalResults: ?number
      |}
    |}
  |}
|};
export type addCartItemMutation = {|
  variables: addCartItemMutationVariables,
  response: addCartItemMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfolioItemsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "ModifyPortfolioItemsInput!"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "items",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioItemsConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "addCartItemMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "modifyPortfolioItems",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyPortfolioItemsPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolio",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "addCartItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "modifyPortfolioItems",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyPortfolioItemsPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolio",
            "storageKey": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "addCartItemMutation",
    "id": "dibs-buyer-layout/222.6.0-2019-06-25T11:58:43.302Z/addCartItemMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '321aa184c3b379ab2a9f986679257e8d';
module.exports = node;
